export default "__VITE_ASSET__V1G6JgEg__"